import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog';
import type { DealStatus } from '@openx/types/deal';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModalContent } from '../components/ConfirmationModalContent';

export type ShowConfirmationModalParams = {
  onConfirmed: () => void;
  onCancel?: () => void;
  isEdit?: boolean;
  currentStatus?: DealStatus;
  statusHasChanged?: boolean;
};

export const useConfirmationModal = () => {
  const { t } = useTranslation();
  const confirmationDialog = useConfirmationDialog();

  const showConfirmationModal = useCallback(
    ({ onConfirmed, isEdit, currentStatus, onCancel, statusHasChanged }: ShowConfirmationModalParams) => {
      const alertMessage = statusHasChanged
        ? currentStatus === 'Active'
          ? 'Reactivating will cause this deal to run without Engagement optimization while request volumes are reassessed.'
          : 'Pausing will cause this deal to run without Engagement optimization while request volumes are reassessed.'
        : null;

      confirmationDialog.open({
        confirmationButtonColor: 'primary',
        confirmationLabel: t('Save'),
        content: <ConfirmationModalContent isEdit={isEdit} statusMessage={alertMessage} />,
        customContent: true,
        onCancel: () => {
          onCancel?.();
          confirmationDialog.close();
        },
        onConfirmed: () => {
          onConfirmed();
          confirmationDialog.close();
        },
        title: t('Confirmation'),
      });
    },
    [confirmationDialog, t]
  );

  return { showConfirmationModal };
};
